import {formateData, headers} from "./index";
import {applicationName} from "../utils";

import request from "../base/request";
let host = "/cm-sites-pms/";

const Apis = {
    imageSourceAdd: host + "imageSource/add", //图片源新增
    imageSourceListInitDataSource: host + "imageSource/list",//图片源列表
    imageSourceUpdate:host+"imageSource/edit",//图片源修改
    imageSourceDelete:host+"imageSource/deleteById",//删除
    imageSourceGetById:host+"imageSource/getById"//回显
};

export const imageSourceAdd = (body, callBack) => {
    request({url: Apis.imageSourceAdd, contentType: "json", method: "post", body, callBack});
};
export const imageSourceListInitDataSource = (body, callBack)  => {
    request({url: Apis.imageSourceListInitDataSource, body, callBack});
};
export const imageSourceUpdate = (body, callBack) => {
    request({url: Apis.imageSourceUpdate, contentType: "json", method: "post", body, callBack});
};
export const imageSourceDelete = (body, callBack) => {
    request({url: Apis.imageSourceDelete, method: "post", body, callBack});
};
export const imageSourceGetById = (body, callBack) => {
    request({url: Apis.imageSourceGetById, body, callBack});
};
// export const imageSourceListInitDataSource = (start, size,mediaCode,treeId,treeContentId, callBack) => {
//     let url = "/cm-sites-" + applicationName() + "/imageSource/list?"+formateData({
//         start,size,mediaCode,treeId,treeContentId
//     });
//     fetch(url, {
//         method: 'get',
//         cache: 'no-cache',
//         headers: headers,
//         credentials: 'include'
//     }).then(response => response.json()).then(data => {
//         callBack(data);
//     }).catch((error) => {
//         console.error("actionError:imageSourceListInitDataSource",error);
//         callBack({});
//     })
// };
// export const imageSourceAdd = (imageSource, callBack) => {
//     let url = "/cm-sites-" + applicationName() + "/imageSource/add";
//     fetch(url, {
//         method: 'post',
//         cache: 'no-cache',
//         headers: headers,
//         credentials: 'include',
//         body: formateData(imageSource)
//     }).then(response => response.json()).then(data => {
//         callBack(data);
//     }).catch((error) => {
//         console.error("actionError:imageSourceListInitDataSource",error);
//         callBack({});
//     })
// };
// export const imageSourceUpdate = (imageSource, callBack) => {
//     let url = "/cm-sites-" + applicationName() + "/imageSource/edit";
//     fetch(url, {
//         method: 'post',
//         cache: 'no-cache',
//         headers: headers,
//         credentials: 'include',
//         body: formateData(imageSource)
//     }).then(response => response.json()).then(data => {
//         callBack(data);
//     }).catch((error) => {
//         console.error("actionError:imageSourceListInitDataSource",error);
//         callBack({});
//     })
// };
// export const imageSourceDelete = (id, callBack) => {
//     let url = "/cm-sites-" + applicationName() + "/imageSource/deleteById";
//     fetch(url, {
//         method: 'post',
//         cache: 'no-cache',
//         headers: headers,
//         credentials: 'include',
//         body: formateData(id)
//     }).then(response => response.json()).then(data => {
//         callBack(data);
//     }).catch((error) => {
//         console.error("actionError:imageSourceListInitDataSource",error);
//         callBack({});
//     })
// };
// export const imageSourceDeletes = (ids, callBack) => {
//     let url = "/cm-sites-" + applicationName() + "/imageSource/deleteByIds";
//     fetch(url, {
//         method: 'post',
//         cache: 'no-cache',
//         headers: {
//             ...headers,
//             "Content-Type" : 'application/json'
//         },
//         credentials: 'include',
//         body: JSON.stringify(ids)
//     }).then(response => response.json()).then(data => {
//         callBack(data);
//     }).catch((error) => {
//         console.error("actionError:imageSourceListInitDataSource",error);
//         callBack({});
//     })
// };